var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder"},[(_vm.pagination)?_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.pagination.itemsPerPage),function(i){return _c('div',{key:("placeholder_" + i),staticClass:"card"})}),0):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }